import * as React from 'react'
import { SEARCH_PAGE_AI_CONTENT_ENABLED_TOGGLE_COOKIE_NAME } from 'constants/cookies'
import { getCookie, setCookie } from 'utils/dom'
import { useUserIsDesigner, useUser } from '@repo/cf-user/hooks/use-user-data'
import { isInternalEmail } from '@repo/utils-internal-user'

export function useAreAIProductsEnabledOnSearch() {
  const isDesigner = useUserIsDesigner()
  const { data: user } = useUser()
  const isCfUser = isInternalEmail(user?.email)

  const [isAiContentEnabled, setIsAiContentEnabled] = React.useState<boolean>(() => {
    const cookieValue = getCookie(SEARCH_PAGE_AI_CONTENT_ENABLED_TOGGLE_COOKIE_NAME)

    // Cookie is not set, so we use the designer status to determine the default value
    if (cookieValue === '') {
      return !!isDesigner
    }

    // Otherwise, we use the cookie value to determine the default value
    return cookieValue === 'true'
  })

  const handleSetIsAiContentEnabled = (enabled: boolean) => {
    if (!isCfUser) {
      return
    }

    setIsAiContentEnabled(enabled)
    setCookie({
      name: SEARCH_PAGE_AI_CONTENT_ENABLED_TOGGLE_COOKIE_NAME,
      value: enabled.toString(),
      path: '/',
      expiresIn: 1000 * 60 * 60 * 24 * 365 * 10, // 10 years
      domain: '.creativefabrica.com',
    })
  }

  return {
    isCfUser,
    isAiContentEnabled: isCfUser ? isAiContentEnabled : false,
    setIsAiContentEnabled: handleSetIsAiContentEnabled,
  }
}
